<template>
  <div class="item" @click="golistdetail(item.nbr)">
    <img class="banner" :src="item.commodity_rect_logo" />
    <div class="countBox" v-if="hasCount || countdowns != '00:00:00'">
      <div class="countTitle">
        <span>活动开团</span>
        <span class="subTitle" v-if="item.is_quantity_show=='1'">剩余{{item.quantity}}份</span>
        <span class="subTitle" v-else-if="item.is_sales_show=='1'">已抢{{item.sales_num}}份</span>
      </div>
      <div class="countText" v-if="hasCount && countdowns == '00:00:00'">
        <span>距离结束还有</span>
        <span v-if="countdown.split(':')[0] != '00'">{{countdown.split(':')[0]}}天</span>
        <span>{{countdown.split(':')[1]}}:{{countdown.split(':')[2]}}:{{countdown.split(':')[3]}}</span>
      </div>
      <div class="countText" v-else-if="countdowns != '00:00:00'">
        <span>距离开始还有</span>
        <span>{{countdowns.split(':')[0]}}:{{countdowns.split(':')[1]}}:{{countdowns.split(':')[2]}}</span>
      </div>
    </div>
    <div class="itemInfo">
      <p class="title">{{item.commodity_name}}</p>
      <p class="desc">{{item.commodity_summary}}</p>
      <div v-if="item.labelArr.length > 0" class="label">
        <div class="labelItem" v-for="(label,index) in item.labelArr" :key="index">
          <span>{{label}}</span>
        </div>
      </div>
      <div class="priceBox">
        <div class="priceLeft">
          <span class="price"><span>¥</span>{{parseFloat(sellPrice)}}</span>
          <!-- <span v-if="roleText!='sell'&&parseFloat(difference) > 0" class="difference">赚{{parseFloat(difference)}}元</span> -->
        </div>
        <div class="priceRight">
          <span class="sales" v-if="item.is_quantity_show=='1'">剩余{{item.quantity}}</span>
          <span class="sales" v-if="item.is_sales_show=='1'">已售{{item.sales_num}}</span>
          <div class="btn">
            <img src="../../assets/images/source/sourceCart.png" />
            <span>购买</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {
    item: {
      type: Object,
    },
    roleText: {
      type: String,
      default: "sell"
    },
  },
  data() {
    return {
      timer:null,
      timers:null,
      hasCount:false,
      countdowns: "",  //预售倒计时
      countdown: "00:00:00:00", //秒杀倒计时
    };
  },
  watch: {},
  computed: {
    sellPrice(){
      let item = this.item
      let roleText = this.roleText
      return item[`min_${roleText}_price`]
    },
    difference(){
      let item = this.item
      let price = parseFloat(item.min_sell_price)-parseFloat(this.sellPrice)+parseFloat(item.own_reward)
      return price.toFixed(2)
    },
    ...mapGetters(["userInfo"])
  },
  methods: {
    golistdetail(nbr) {
      this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
    },
    getData(){
      this.preSaleTimer()
      this.timers = setInterval(() => {
        this.preSaleTimer();
      }, 1000);
      if (this.item.end_time == `2030-01-01 00:00:00`) return false;
      this.countTimer();
      this.timer = setInterval(() => {
        this.countTimer();
      }, 1000);
    },
    preSaleTimer() {
      let date = new Date();
      let toTime = this.item.start_time.replace(/\-/g, "/");
      let thisTime = `${date.getFullYear()}/${
        date.getMonth() + 1
      }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(toTime) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTamp <= 0) {
        timeText = `00:00:00`;
        clearInterval(this.timers)
        this.timers = null
      } else {
        timeText = `${this.addZero(
          parseInt(timeTamp / (60 * 60))
        )}:${this.addZero(parseInt((timeTamp / 60) % 60))}:${this.addZero(
          parseInt(timeTamp % 60)
        )}`;
      }
      this.countdowns = timeText;
    },
    countTimer() {
      let date = new Date();
      let toTime = this.item.end_time.replace(/\-/g, "/");
      let thisTime = `${date.getFullYear()}/${
        date.getMonth() + 1
      }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(toTime) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTamp <= 0) {
        timeText = `00:00:00:00`;
        this.hasCount=false
        clearInterval(this.timer)
        this.timer = null
      } else {
        timeText = `${this.addZero(
          parseInt(timeTamp / (60 * 60 * 24))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTamp % 60))}`;
        this.hasCount=true
      }
      this.countdown = timeText;
    },
    addZero(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
  destroyed(){
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.timers) {
      clearInterval(this.timers)
      this.timers = null
    }
  },
}
</scripts>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
  .item{
    width: 7.1rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 4px rgba(0,0,0,0.04);
    margin-bottom: .2rem;
  }
  .banner{
    width: 7.1rem;
    height: 3.22rem;
    object-fit: cover;
  }
  .countBox{
    width: 100%;
    height: .8rem;
    background-image: linear-gradient(270deg, #FAFCBB 0%, #E9FAB6 51%, #B0F3A5 100%);
    box-sizing: border-box;
    padding: 0 .2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .countTitle{
    display: flex;
    height: .44rem;
    flex-direction: row;
    align-items: baseline;
    span:first-child{
      font-size: .32rem;
      color: #333;
      line-height: .44rem;
      font-weight: bold;
    }
    .subTitle{
      font-size: .24rem;
      color: #505050;
      margin-left: .1rem;
      font-weight: 400;
    }
  }
  .countText{
    display: flex;
    height: .4rem;
    flex-direction: row;
    align-items: center;
    span{
      font-size: .28rem;
      color: #333;
      font-weight: 500;
    }
  }
  .itemInfo{
    width: 100%;
    box-sizing: border-box;
    padding: .2rem;
    .title{
      font-size: .28rem;
      color: #333;
      line-height: .4rem;
      font-weight: bold;
    }
    .desc{
      margin-top: .1rem;
      font-size: .26rem;
      color: #5E5E5E;
      line-height: .37rem;
      font-weight: 500;
    }
    .label{
      width: 100%;
      margin-top: .2rem;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-bottom: -.1rem;
      .labelItem{
        box-sizing: border-box;
        height: .42rem;
        border: .02rem solid #09C35D;
        padding: 0 .1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: .1rem;
        margin-bottom: .1rem;
        border-radius: .08rem;
        span{
          font-size: .22rem;
          color: #09C35D;
          font-weight: 400;
        }
      }
    }
    .priceBox{
      margin-top: .2rem;
      height: .48rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .priceLeft{
        display: flex;
        flex-direction: row;
        align-items: baseline;
        .price{
          line-height: .48rem;
          font-size: .34rem;
          color: #FD0000;
          font-weight: bold;
          span{
            font-size: .24rem;
            font-weight: 400;
          }
        }
        .difference{
          margin-left: .06rem;
          font-size: .22rem;
          color: #FD0000;
          font-weight: 500;
        }
      }
      .priceRight{
        display: flex;
        flex-direction: row;
        align-items: center;
        .sales{
          margin-right: .1rem;
          font-size: .24rem;
          color: #999;
          font-weight: 400;
        }
        .btn{
          width: 1.4rem;
          height: .48rem;
          border-radius: .24rem;
          background: #06C35D;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          img{
            width: .3rem;
            height: .3rem;
            margin-right: .14rem;
          }
          span{
            font-size: .26rem;
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/sourceItem.vue